import script from "./DynamicAppTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTextElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTextElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppTextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a5efa04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a5efa04', __exports__)) {
    api.reload('1a5efa04', __exports__)
  }
  
}


export default __exports__